import {
  buildPath,
  buildTemplatePath,
  Page,
  PageRoute,
  Stack,
  Typography,
  useElementBreakpoints,
  useValidationErrors,
} from "@compass/core";
import { SubmitButton } from "components";
import {
  AprRequest,
  AprRequestFilter,
  AprResource,
  AprUBResponse as AprResponseModel,
  Permission,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import produce from "immer";
import { ScreenType } from "../AprPage/AprPage";
import { AprPageHeader } from "../AprPage/AprPageHeader";
import { AprUbFilters } from "./AprUbFilters";
import { AprUbResponse } from "./AprUbResponse";

const routeName = "aprub";

export const aprUbPageRoute: PageRoute = {
  handle: "APR UB/UBMS",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const AprUbPage = () => {
  const ROOT_PERMISSION: Permission = Permission.EdReport;
  const navigate = useNavigate();
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const [request, setRequest] = useState<AprRequest>({} as AprRequest);
  const [resource, setResource] = useState<AprResource>({});
  const [response, setResponse] = useState<AprResponseModel>();
  const [screen, setScreen] = useState<ScreenType>("config");

  const selectedAprSchoolYear = resource.aprSchoolYears?.find((x) => x.id === request.filter?.aprSchoolYearId);
  const aprSections = resource.aprSections?.filter((x) => selectedAprSchoolYear?.sections.includes(x.id)) || [];

  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    ApiService.apr.getRequest().then((response) => {
      setRequest(response);
    });

    ApiService.apr.getResource().then((response) => {
      setResource(response);
    });
  }, []);

  useEffect(() => {
    setRequest(produce(request, (draft) => {
      draft.sectionItemIds = [];
    }));
  }, [request.filter?.aprSchoolYearId]);

  const generate = () => {
    ApiService.apr.generateAprUb(request).then((response) => {
      setResponse(response);
      setScreen("report");
    });
  };

  return (
    <Page
      isForm
      header={
        <AprPageHeader handle={aprUbPageRoute.handle} screen={screen} filter={request?.filter} setScreen={setScreen} generateReport={generate} />
      }
    >
      <Stack spacing="md">
        {screen === "config" ? (
          <>
            <AprUbFilters
              filter={request?.filter || ({} as AprRequestFilter)}
              setFilter={(value) => setRequest({ ...request, filter: value })}
              resource={resource}
              validationErrors={validationErrors}
            />
          </>
        ) : (
          <AprUbResponse
            filter={request?.filter || ({} as AprRequestFilter)}
            resource={resource}
            response={response || {}}
            aprSections={resource.aprSections || []}
            selectedSectionItemIds={request?.sectionItemIds || []}
          />
        )}
      </Stack>
    </Page>
  );
};
